import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  responseType: 'json',
});

api.interceptors.request.use((req) => {
  const token = process.env.REACT_APP_GITHUB_TOKEN;

  if (token) {
    req.headers = {
      ...req.headers,
      Authorization: `token ${token}`,
    };
  }

  return req;
});

export default api;
